import { Button } from '@acpaas-ui/react-components';
import _ from 'lodash';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { resourceReset } from '../actions/resources.actions';
import SimpleSearch from '../components/core/SimpleSearch';
import Tooltip from '../components/core/Tooltip';
import { MODALS } from '../constants/modals.constants';
import ResourceTable from '../containers/core/ResourceTable';
import { useModal } from '../hooks/useModal.hook';
import { useSimpleSearch } from '../hooks/useSimpleSearch.hook';
import { addStakeholderBody } from '../lib/stakeholder.utils';
import { DOSSIER_STAKEHOLDER_CONTACTS_RESOURCE } from '../resources/dossier.stakeholder.contacts.resource';
import { tableDataSelector, tableSelectedSelector } from '../selectors/resources.selectors';
import AddContactModal from './admin/AddContactModal';
import Modal from './Modal';
import ModalTitle from './ModalTitle';

const contactsResource = {
  ...DOSSIER_STAKEHOLDER_CONTACTS_RESOURCE,
  table: { ...DOSSIER_STAKEHOLDER_CONTACTS_RESOURCE.table, disablePagination: true, enableSelect: true }
};

const AssignedToDossierSearchContactsModal = ({ isOpen, onConfirm, onClose }) => {
  const dispatch = useDispatch();
  const tooltipId = useRef(uuid()).current;
  const modalContentRef = useRef(null);
  const selected = useSelector((state) => tableSelectedSelector(state, { resource: contactsResource }));
  const { data } = useSelector((state) => tableDataSelector(state, { resource: contactsResource }));
  const addContactModal = useModal(MODALS.ADD_CONTACT_MODAL);
  const [showTable, setShowTable] = useState(false);

  const search = useSimpleSearch(contactsResource, 'name', true);

  const reset = () => {
    search.onChange('');
    setShowTable(false);
    dispatch(resourceReset(contactsResource));
  };

  const handleClose = () => {
    onClose();
    reset();
  };

  const handleConfirm = () => {
    const selectedToAssign = data?.filter((c) => selected.includes(c.id));
    onConfirm(
      selectedToAssign?.map((c) => ({
        ..._.omit(addStakeholderBody(c), 'role'),
        phone: c?.phone ?? ''
      }))
    );
    handleClose();
  };

  const handleContactCreated = (createdContact) => {
    // TODO SPO-331
    onConfirm([
      {
        id: createdContact?.id,
        email: createdContact?.spoContactData?.email ?? '',
        firstname: createdContact?.spoContactData?.firstName ?? '',
        lastname: createdContact?.spoContactData?.lastName ?? '',
        phone: createdContact?.spoContactData?.phone ?? ''
      }
    ]);
    handleClose();
  };

  const handleSearch = () => {
    search.onSearch();
    setShowTable(true);
  };

  return (
    <>
      <Modal
        ref={modalContentRef}
        title={<ModalTitle title="Toegekend aan" />}
        isOpen={isOpen}
        onClose={handleClose}
        canConfirm={selected?.length > 0}
        onConfirm={handleConfirm}
        onConfirmLabel="Toewijzen"
        onConfirmIcon="ai-check-1"
        onConfirmType="success"
        width={1000}
        extraFooterActions={
          <Button iconLeft="ai-add" onClick={addContactModal.onOpen} outline>
            Contact aanmaken
          </Button>
        }
      >
        <SimpleSearch
          className="u-margin-bottom"
          {...search}
          onClear={() => search.onChange('')}
          onSearch={handleSearch}
        />
        {showTable && <ResourceTable resource={contactsResource} />}
      </Modal>
      <Tooltip id={tooltipId} />
      {addContactModal.isOpen && <AddContactModal {...addContactModal} onCreated={handleContactCreated} />}
    </>
  );
};

export default AssignedToDossierSearchContactsModal;
